"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiRecourtCreditCorporation = void 0;
exports.ESubScpiRecourtCreditCorporation = {
    oui: "oui",
    non: "non",
    neSaisPas: "neSaisPas",
};
